import React from 'react'
// import { dashboardService } from '../../../_services/Dashboard.service'
import { connect } from 'react-redux'
import { Dropdown } from 'semantic-ui-react'

class YearSelect extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      data: [],
      selected: '',
      loading: false,
      defaultValue: this.props.defaultValue,
    };

  }

  // componentWillMount() {
  //   this.getData()
  // }

  // async getData() {

  //   this.setState({ loading: true })

  //   await dashboardService.date()
  //     .then((res) => {
  //       let arr = res.data.years;
  //       // // console.log(arr);
  //       var items = arr.map(el => ({text: el, value: el, key: el}));

  //       this.setState({ data: items, loading: false });

  //     })
  //     .catch((error) => {
  //       this.setState({ loading: false })
  //     });

  // };

  async componentWillReceiveProps(nextProps) {
    if (nextProps.defaultValue !== this.state.defaultValue) {
      this.setState({ defaultValue: nextProps.defaultValue });
    }
    if (nextProps.data !== this.state.data) {
      this.setState({ data: nextProps.data.map(el => ({text: el, value: el, key: el})) });
    }
  }

  // shouldComponentUpdate(nextProps){
  //   return true;
  // }

  handleChange = (e) => {

    let selected = e;
    this.setState({ selected: selected })
    this.props.onChange(selected)

  }



  render() {

    const { data, loading, defaultValue } = this.state;
    const { clearable, disabled } = this.props;

    return (
      <Dropdown
        placeholder='سال'
        fluid
        search
        selection
        basic
        onChange={(e, data) => this.handleChange(data.value)}
        value={defaultValue}
        className="semantic-select-box"
        options={data}
        wrapSelection={false}
        selectOnBlur={false}
        searchInput={{ autoFocus: false }}
        loading={loading}
        disabled={disabled}
        clearable={clearable}
      />
    );
  }
}

function mapStateToProps(state) {
  const { authentication } = state;
  const { user } = authentication;
  return {
    user
  };
}

const connectedYearSelect = connect(mapStateToProps)(YearSelect);
export { connectedYearSelect as YearSelect };